import ApplicationController from 'javascript/controllers/application_controller';
import { Rails } from 'javascript/utils/rails_polyfills';
import fullScreenSpinner from 'javascript/utils/full-screen-spinner';

const CALLPAY_ORIGIN_RGX = /^https:\/\/([^./]*)\.callpay\.com(\/|$)/;

export default class extends ApplicationController {
  static targets = [
    'container',
    'form',
    'installments',
    'repaymentDate',
    'totalAmount',
    'submit',
  ];

  connect() {
    this.window.addEventListener('message', this.callpayClosed, false);
    this.abortPath = null;
  }

  disconnect() {
    this.window.removeEventListener('message', this.callpayClosed);
  }

  before(_event) {
    // Show loading state
    this.containerTarget.classList.add('contents-loading');
    this.submitTarget.setAttribute('disabled', 'disabled');
    this.abortPath = null;
    fullScreenSpinner.show();
  }

  success(event) {
    const [response, _status, _xhr] = event.detail;

    // Hide modal loading state
    this.containerTarget.classList.remove('contents-loading');

    // Store abort path for cleanup
    this.abortPath = response.abort_path;

    // Initialize CallPay checkout with the payment key
    // For ballot payment plans, we always want to tokenize the card (rememberCard: true)
    // The display_check_box parameter controls whether to show a checkbox to the user
    this.processCallpayPayment(
      response.payment_key,
      response.display_check_box !== undefined
        ? response.display_check_box
        : true,
    );
  }

  error(event) {
    const [response, _status, _xhr] = event.detail;

    this.containerTarget.classList.remove('contents-loading');
    this.submitTarget.removeAttribute('disabled');
    fullScreenSpinner.hide();

    alert(`Error: ${response.error || 'Payment creation failed'}`);
    this.abortPath = null;
  }

  processCallpayPayment(paymentKey, showCheckbox) {
    // Configure CallPay checkout
    window.eftSec.checkout.settings.serviceUrl =
      'https://howler.callpay.com/rpp-transaction/create-from-key';

    // Initialize CallPay modal/iframe
    // For ballot payment plans, we always want to tokenize the card (rememberCard: true)
    // The display_check_box parameter controls whether to show a checkbox to the user
    window.eftSec.checkout.init({
      paymentKey,
      paymentType: 'credit_card',
      cardOptions: {
        rememberCard: showCheckbox,
        rememberCardDefaultValue: 1,
      },
    });
  }

  callpayClosed = (event) => {
    if (
      CALLPAY_ORIGIN_RGX.test(event.origin) &&
      typeof event.data === 'string'
    ) {
      // CallPay sends executable code - we need to execute it safely
      // This is required by CallPay's SDK to close the modal properly
      // eslint-disable-next-line no-new-func
      const callpayFunction = new Function(event.data);
      callpayFunction();

      if (/hideFrame/.test(event.data)) {
        fullScreenSpinner.hide();
        this.submitTarget.removeAttribute('disabled');

        // If user closed the modal without completing payment, call abort endpoint
        if (this.abortPath) {
          Rails.ajax({ url: this.abortPath, type: 'POST' });
          this.abortPath = null;
        }
      }
    }
  };
}
